














import { Component, Vue } from "vue-property-decorator";
import { MediaType } from "@/services/files/types";
import { FILEENDPOINT } from "@/app.config";

@Component
export default class FilePreviewModal extends Vue {
    fileId = "";
    name = "";
    mediaType = MediaType.Document;
    mediaTypes = MediaType;
    loading = true;
    // lifecycle hooks

    // computed
    get fileSrc(): string {
        return `${FILEENDPOINT}${this.fileId}`;
    }

    // methods
    open(fileId: string, mediaType: MediaType, name: string) {
        this.fileId = fileId;
        this.name = name;
        this.mediaType = mediaType;
        this.$bvModal.show("modal-filePreview");
        if (this.mediaType === this.mediaTypes.Video) {
            this.loadVideo();
        }
    }

    loadVideo() {
        const scope = this;
        Vue.nextTick(function () {
            const video = scope.$refs.video as HTMLVideoElement;
            video.autoplay = true;
            video.onloadeddata = () => {
                scope.loading = false;
            };
            video.src = scope.fileSrc;
        });
    }

    hide() {
        this.$bvModal.hide("modal-filePreview");
    }
}
